import styled, { css, keyframes } from 'styled-components';
import { getCDNImageUrl } from '@/helpers/cdn';
import { device } from '@/styles/helpers';

const flareAppear = keyframes`
  0%, 100% {
    opacity: 0;
  }

  15% {
    opacity: 1;
  }

  25% {
    opacity: 1;
  }

  40% {
    opacity: 0;
  }
`;

const leftLightImage = getCDNImageUrl('/headline-promo/left_light.webp');
const rightLightImage = getCDNImageUrl('/headline-promo/right_light.webp');

export const ScCharacterImage = styled.div<{ $disableAnimation?: boolean }>`
  position: relative;
  max-width: 520px;
  margin: 0 auto;

  @media (${device.mobile}) {
    max-width: none;
    margin: -48px -16px 0;
  }

  .device {
    display: block;
    max-width: 520px;
    width: 100%;
    height: auto;
    object-fit: cover;
    margin: 0 auto -265px;
    max-height: 523px;

    @media (${device.mobile}) {
      margin: 0 auto -215px;
    }
  }

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    pointer-events: none;
    opacity: 0;
    animation: ${flareAppear} 6s ease-in-out infinite;

    ${({ $disableAnimation }) =>
      $disableAnimation &&
      css`
        display: none;
      `}
  }

  &::before {
    right: 77%;
    width: 334px;
    top: 15%;
    height: 94px;
    background-image: url(${leftLightImage});

    @media (${device.mobile}) {
      right: 72%;
      top: 20%;
    }
  }

  &::after {
    left: 76%;
    top: 25%;
    width: 438px;
    height: 94px;
    background-image: url(${rightLightImage});
    animation-delay: 1.2s;
    @media (${device.mobile}) {
      left: 68%;
      top: 29%;
    }
  }
`;
